export class TorchWeeklyTdrWarReport {
  id: number;
  warReportDate: Date;
  type: string;
  fleetCode: string;
  revenueDepartures: number;
  m2Count: number;
  removalM2Count: number;
  tdr: number;
  componentTdr: number;
  tdrTarget: number;
}
